import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=dbcdae52"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=dbcdae52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports